import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import moment from 'moment'
import extract, {sanitize, replace} from '../../core/extract'
import DashboardPanel from '../../core/components/DashboardPanel'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import style from './DocumentDashboardPanel.less'
import logoActradis from '../resources/img/logo-actradis.png'

class DocumentDashboardPanel extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {provider} = this.props

        const documents = provider && provider.documents || []
        const undeclaredWorkDocuments = documents.filter((d) => d.documentCategory == 'UndeclaredWorkDocument')
        const insuranceDocuments = documents.filter((d) => d.documentCategory == 'InsuranceDocument')
        const specificDocuments = documents.filter((d) => d.documentCategory == 'SpecificDocument')
        const otherDocuments = documents.filter((d) => d.documentCategory == 'OtherDocument')

        this.setState({undeclaredWorkDocuments, insuranceDocuments, specificDocuments, otherDocuments})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.provider != this.props.provider) {
            const {provider} = nextProps

            const documents = provider && provider.documents || []
            const undeclaredWorkDocuments = documents.filter((d) => d.documentCategory == 'UndeclaredWorkDocument')
            const insuranceDocuments = documents.filter((d) => d.documentCategory == 'InsuranceDocument')
            const specificDocuments = documents.filter((d) => d.documentCategory == 'SpecificDocument')
            const otherDocuments = documents.filter((d) => d.documentCategory == 'OtherDocument')

            this.setState({undeclaredWorkDocuments, insuranceDocuments, specificDocuments, otherDocuments})
        }
    }

    _openDocumentWindow(event, document) {
        event.preventDefault()
        window.open(document.urlForDownload, '_blank')
    }

    render() {
        const {dispatch, provider, ...others} = this.props
        const {undeclaredWorkDocuments, insuranceDocuments, specificDocuments, otherDocuments} = this.state

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        const replaceValidityDates = (value, document) => {
            return replace(value, {
                startDate: moment(document.startValidityDate).format(i18n.dateFormat.default),
                endDate: moment(document.endValidityDate).format(i18n.dateFormat.default)
            })
        }

        const documentItem = (document, index) => (
            <li
                className={style[sanitize(document.state)]}
                key={index}>
                <a
                    href=''
                    onClick={(e) => this._openDocumentWindow(e, document)}>
                    {document.state == 'OK' && (
                        <Icon icon='check' size='xs' />
                    )}
                    {document.state != 'OK' && (
                        <b>!</b>
                    )}
                    <span>{document.label}</span>
                </a>
            </li>
        )

        return (
            <DashboardPanel
                header={panelHeader(i18n.documents)}
                status='success'
                {...others}>
                <div className={style.defaultContent}>
                    <div className={style.documentGroup}>
                        <h4>
                            <Icon icon='undeclaredWork' size='xs' />
                            <span>{i18n.undeclaredWorkDocuments}</span>
                        </h4>
                        {undeclaredWorkDocuments.length == 0 && (
                            <small>
                                <b>></b>
                                <span>{i18n.emptyDocuments}</span>
                            </small>
                        )}
                        <ul>
                            {undeclaredWorkDocuments.map(documentItem)}
                        </ul>
                    </div>
                    <div className={style.documentGroup}>
                        <h4>
                            <Icon icon='insurance' size='xs' />
                            <span>{i18n.insuranceDocuments}</span>
                        </h4>
                        {insuranceDocuments.length == 0 && (
                            <small>
                                <b>></b>
                                <span>{i18n.emptyDocuments}</span>
                            </small>
                        )}
                        <ul>
                            {insuranceDocuments.map(documentItem)}
                        </ul>
                    </div>
                    <div className={style.documentGroup}>
                        <h4>
                            <Icon icon='star' size='xs' />
                            <span>{i18n.specificDocuments}</span>
                        </h4>
                        {specificDocuments.length == 0 && (
                            <small>
                                <b>></b>
                                <span>{i18n.emptyDocuments}</span>
                            </small>
                        )}
                        <ul>
                            {specificDocuments.map(documentItem)}
                        </ul>
                    </div>
                    <div className={style.documentGroup}>
                        <h4>
                            <Icon icon='star' size='xs' />
                            <span>{i18n.otherDocuments}</span>
                        </h4>
                        {otherDocuments.length == 0 && (
                            <small>
                                <b>></b>
                                <span>{i18n.emptyDocuments}</span>
                            </small>
                        )}
                        <ul>
                            {otherDocuments.map(documentItem)}
                        </ul>
                    </div>
                    <div className={style.logo}>
                        <img src={logoActradis} />
                    </div>
                </div>
            </DashboardPanel>
        )
    }
}

DocumentDashboardPanel = connect((state) => ({
	provider: state.actradis.provider.provider
}))(DocumentDashboardPanel)

export default DocumentDashboardPanel


// WEBPACK FOOTER //
// ./lib/actradis/components/DocumentDashboardPanel.js